// extracted by mini-css-extract-plugin
export default {"-large":"text-with-info-module__-large--dhEpT","container":"text-with-info-module__container--V2Yf_"};